import React, { useRef } from "react";

import cn from "classnames";
import s from "./InformationButton.module.scss";
import { Popover, PopoverProps } from "@progress/kendo-react-tooltip";
import { useClickAway } from "react-use";

interface IOwnProps extends PopoverProps {
  text: string;
  extraClass?: string;
  invert?: boolean;
}

const DISABLED_FOR_NOW = false;

export const ConnectedInformationButton = ({
  text,
  children,
  extraClass,
  invert,
  ...rest
}: React.PropsWithChildren<IOwnProps>) => {
  const anchor = useRef<HTMLInputElement>(null);
  const [show, setShow] = React.useState(false);
  const small = false;

  const divProps = React.useMemo(() => {
    if (small) {
      return { onClick: () => (show ? setShow(false) : setShow(true)) };
    } else {
      return {
        onMouseEnter: () => setShow(true),
        onMouseLeave: () => setShow(false),
      };
    }
  }, [small, show]);

  useClickAway(anchor, (e) => {
    if (show) {
      setShow(false);
    }
  });

  if (!text) {
    return <>{children}</>;
  }
  return (
    <div className={cn(s.container, extraClass, invert && s.reverse)}>
      {children}
      {!DISABLED_FOR_NOW && (
        <>
          <div ref={anchor} className={cn(s.infoButtonSurround)} {...divProps}>
            i
          </div>
          <Popover
            data-cy={"k-popup"}
            show={show}
            anchor={anchor.current}
            position={"right"}
            animate={false}
            collision={{
              vertical: "flip",
              horizontal: "flip",
            }}
            style={{ maxWidth: 200 }}
            {...rest}
          >
            <div>{text}</div>
          </Popover>
        </>
      )}
      {/*<div className={cn(s.content)}>{information?.text ?? code}</div>*/}
    </div>
  );
};
